import {
  Shield,
  ScanSearch,
  Send,
  Reply,
  Info,
  X,
  Copy,
  Eye,
  Filter,
  Globe,
  Link2,
  Activity,
  Network,
  Fingerprint,
  ShieldAlert,
  Target,
  Crosshair,
  ArrowLeft,
  Download,
  ChevronDown,
  CircleDot,
  ListTree,
  Database,
  FileText,
  Ban,
  Sparkles,
  Wrench,
  ClipboardList,
} from "lucide-react";

/** Lucide icons for detection drawers, filters, event tables, and detail views. */
export const DETECTION_ICONS = {
  wafDetection: Shield,
  detection: ScanSearch,
  request: Send,
  response: Reply,
  info: Info,
  close: X,
  copy: Copy,
  view: Eye,
  filter: Filter,
  hostname: Globe,
  uri: Link2,
  status: Activity,
  ip: Network,
  ja3: Fingerprint,
  ipReputation: ShieldAlert,
  match: Target,
  campaign: Crosshair,
  back: ArrowLeft,
  download: Download,
  chevronDown: ChevronDown,
  responseStatus: CircleDot,
  header: ListTree,
  cache: Database,
  contentNegotiation: FileText,
  requestBlocked: Ban,
  ml: Sparkles,
  wrench: Wrench,
  clipboard: ClipboardList,
};
